<template>
  <div
    class="lm-qms-watch form-group"
    :class="[
      alignClass
    ]"
  >
    <div id="clock">
      <div class="date">{{ clock.date }}</div>
      <div class="time">{{ clock.time }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    dateFormat: {
      type: String,
      default: 'DD-MM-YYYY'
    },
    timeFormat: {
      type: String,
      default: 'HH:MM:ss'
    }
  },
  data () {
    return {
      clock: {
        time: '',
        date: ''
      }
    }
  },
  computed: {
    alignClass () {
      if (this.align === 'center') {
        return 'justify-content-center'
      } else if (this.align === 'left') {
        return 'justify-content-left'
      } else if (this.align === 'right') {
        return 'justify-content-end'
      } else {
        return 'justify-content-center'
      }
    }
  },
  methods: {
    updateTime () {
      const cd = new Date()
      this.clock.date = moment(cd).format(this.dateFormat)
      this.clock.time = moment(cd).format(this.timeFormat)
    }
  },
  mounted () {
    setInterval(this.updateTime, 1000)
    this.updateTime()
  }
}
</script>

<style lang="sass" scoped>
  #clock
    color: #000
    .time
      letter-spacing: 0.05em
    .date
      letter-spacing: 0.1em
    .text
      letter-spacing: 0.1em
</style>
